import * as pdfjsLib from "pdfjs-dist";
import mammoth from "mammoth";

export async function extractTextFromFile(url: string, fileName: string): Promise<string> {
    const extension = fileName.split(".").pop()?.toLowerCase();
    const res = await fetch(url);
    if (!res.ok) throw new Error("Datei konnte nicht geladen werden");
    const blob = await res.blob();

    if (extension === "txt") {
        return await blob.text();
    } else if (extension === "pdf") {
        const arrayBuffer = await blob.arrayBuffer();
        const pdf = await pdfjsLib.getDocument({ data: arrayBuffer }).promise;
        let text = "";
        for (let i = 1; i <= pdf.numPages; i++) {
            const page = await pdf.getPage(i);
            const content = await page.getTextContent();
            text += content.items.map((item: any) => item.str).join(" ") + "\n";
        }
        return text;
    } else if (extension === "docx" || extension === "doc") {
        const arrayBuffer = await blob.arrayBuffer();
        const result = await mammoth.extractRawText({ arrayBuffer });
        return result.value;
    } else {
        console.warn("Nicht unterstützter Dateityp:", fileName);
        return "";
    }
}